import React from 'react';
import TaskList from '../task-list/TaskList';
import {useState} from 'react'
import upImg from 'assets/img/up.svg'
import {IconButton } from 'material-ui';
import './task-group.scss'

const TaskGroup = ({type, items}) => {
    const [itemsToShow, setItems] = useState(3)

    const showMoreHandler = () => {
        setItems(prev => prev + 3)
    }
    
    const collapseHandler = () => {
        setItems(3)
    }

    const tasksToShow = items.slice(0, itemsToShow)
    return (
        <div className={`task-group ${itemsToShow > 3 ? "expanded" : ""}`} >
            <div className='task-group-wrapper'>
                <h4>{type}</h4>
                {
                    itemsToShow > 3 && 
                        <IconButton 
                            className='collaple-list-btn'
                            onClick={collapseHandler}
                        >
                            <img src={upImg} alt="up"/>
                        </IconButton>
                }
                <div className='group-wrapper'>
                    <TaskList tasks={tasksToShow}/>
                    <button onClick={showMoreHandler}>Show more</button>
                </div>
            </div>
        </div>
    );
};

export default TaskGroup;